import {LoadingDots} from '#/atoms/dots-loading-indicator';
import {
  ActionMenuHeader,
  ActionMenuHeaderButton,
  ActionMenuHeaderIcons,
  ActionMenuHeaderLoading,
} from '#/components/actionmenu/action-menu-header';
import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {Land} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {useQueryParams} from 'use-query-params';

export const ActionMenuLandLoading: FunctionComponent<{land: Land | undefined}> = ({land}) => {
  const {t} = useTranslation('translation');

  const [{landToken}] = useQueryParams<SLQueryParamConfig>();

  const isLoading = !land;

  const {
    actionMenu: {close},
  } = useQueryNavigationActions();

  return (
    <>
      {isLoading ? (
        <ActionMenuHeaderLoading />
      ) : (
        <ActionMenuHeader land={land} landMarketInfo={undefined}>
          <ActionMenuHeaderButton onClick={close}>
            <ActionMenuHeaderIcons.Close />
          </ActionMenuHeaderButton>
        </ActionMenuHeader>
      )}

      <div className='h-full flex-center flex-col gap-6'>
        <LoadingDots />
        <span className='text-white font-bold'>
          {isLoading
            ? t('pages.actionMenu.locationLoading.statusLoadingName')
            : t('pages.actionMenu.locationLoading.statusLoadingData', {
                landTokenSymbol: landToken,
              })}
        </span>
      </div>
    </>
  );
};
